/**
 * Wie werden AGB-, Widerrufs- und Datenschutzerklärung im Bestellabschluss abgefragt?
 *
 * Entspricht den Werten der Konfiguration 'offer.privacyDisclaimerAgbInOneField'.
 */
export enum DisclaimerMode {
  /** 0 - je Erklärung eine eigene Pflicht-Checkbox */
  SEPARATE_CHECKBOXES = 0,
  /** 1 - eine Pflicht-Checkbox für alle Erklärungen zusammen (order_privacyDisclaimerAgb) */
  ONE_CHECKBOX = 1,
  /** 2 - keine Checkbox, nur der Erklärungstext direkt über dem Bestell-Button (P5W-4396) */
  TEXT_WITHOUT_CHECKBOX = 2
}

/**
 * Wandelt den Konfigurationswert in den Abfrage-Modus um. Unbekannte oder fehlende Werte führen zu
 * getrennten Checkboxen, weil das die restriktivste Variante ist.
 */
export function toDisclaimerMode(configValue: string | undefined): DisclaimerMode {
  switch (configValue) {
    case '0':
    case 'false':
      return DisclaimerMode.SEPARATE_CHECKBOXES;
    case '1':
    case 'true':
      return DisclaimerMode.ONE_CHECKBOX;
    case '2':
      return DisclaimerMode.TEXT_WITHOUT_CHECKBOX;
    default:
      console.warn(`Ungültiger Wert '${configValue}' für Konfiguration 'offer.privacyDisclaimerAgbInOneField' - es werden getrennte Checkboxen abgefragt.`);
      return DisclaimerMode.SEPARATE_CHECKBOXES;
  }
}
